/* globals */
'use strict';

import * as _codes from './consts-codes.js';
import * as _headers from './consts-headers.js';
import * as _methods from './consts-methods.js';
import * as _types from './consts-types.js';

/**
 * @type {CONSTSCODES}
 */
export const codes = _codes;

	/**
	 * @type {CONSTSHEADERS}
	 */
export const headers = _headers;

/**
 * @type {CONSTSMETHODS}
 */
export const methods = _methods;

/**
 * @type {CONSTSTYPES}
 */
export const types = _types;
